/**
 * Main Entry Point
 */

// This is used by firebase to measure the first input delay metric.
import 'first-input-delay';

// Enable Immer MapSet plugin for Map and Set support
import { enableMapSet } from 'immer';
enableMapSet();

import { createPortal } from 'react-dom';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

// CSS
import { GlobalStyle, PopoverZIndexProvider } from '@solinkcorp/solink-components';
import { Toaster } from '@solinkcorp/solink-ui';
import '@solinkcorp/solink-ui/globals.css';
import 'env/themeVariables';
import { initColorTheme } from './hooks/useColorTheme';
import { router } from './router';

// Apply the stored light/dark theme when the Aspen shell last allowed it.
// The index.html inline script handles the pre-paint case; this keeps the
// class correct when that script does not run. Temporary Aspen gate: see
// setColorThemeAspenShell — remove that once everyone is on Aspen.
initColorTheme();

// Hide the loader once this runs
const loader = document.getElementById('static-loading-wrapper');
if (loader) {
  loader.style.display = 'none';
}

/**
 * Initial Render
 */

const rootEl = document.getElementById('content');
if (!rootEl) {
  throw new Error('No content element');
}
const root = ReactDOM.createRoot(rootEl);

root.render(
  <PopoverZIndexProvider>
    <GlobalStyle />
    <RouterProvider router={router} />
    {/*
      Portal the toaster to <body> so it escapes the #content stacking context.
      Otherwise every modal portaled to #modal-container paints over the toast.
    */}
    {createPortal(<Toaster position="top-center" />, document.body)}
  </PopoverZIndexProvider>,
);
